import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const GradesSetupLazy = React.lazy(
	() => import(/* webpackChunkName : 'GradesSetup' */ './components/GradeSetup')
);

export default (store) => {
	return {
		path: 'grades-setup/:campusId?',
		element: <AsyncLoading component={<GradesSetupLazy />} />,
	};
};
